import { PropsWithChildren } from 'react';

import cn from 'classnames';

import { ReactComponent as CloseIcon } from 'assets/icons/XCircle.svg';
import { ModalSize } from 'types/components/modal.types';

import { useTheme } from 'themes/themeProvider';
import styles from './RootModalLayout.module.scss';

type Props = {
  onClose?: () => void;
  title?: string;
  className?: string;
  size?: ModalSize;
  includeHeader?: boolean;
  testId?: string;
  showCloseIcon?: boolean;
};

const RootModalLayout = ({
  children,
  title,
  className,
  showCloseIcon = true,
  size = 'small',
  testId = 'root-modal',
  includeHeader = true,
  onClose,
}: PropsWithChildren<Props>) => {
  const { theme } = useTheme();

  const handleClose = () => {
    onClose?.();
  };

  return (
    <div className={cn(styles.overlay, className)} onClick={handleClose} data-testid={testId}>
      <div className={cn(styles.modal, styles[`modal-${size}`])} onClick={e => e.stopPropagation()}>
        {includeHeader && (
          <section className={styles.header}>
            <h3 className={styles.title}>{title}</h3>
            {showCloseIcon && (
              <CloseIcon
                className={styles.closeIcon}
                style={{
                  color: theme.buttons.primary.color,
                }}
                onClick={handleClose}
              />
            )}
          </section>
        )}

        {children}
      </div>
    </div>
  );
};

export default RootModalLayout;
